module.exports = __webpack_public_path__ + "img/asamblea26082025.fff075ac.jpg";